// @flow

import React, { Component } from 'react';

import * as Drip from '../utils/drip';
import type { DripPayload } from '../utils/drip';
import validateEmail from '../utils/validate-email';

import Button from './Button';
import LabeledInput from './LabeledInput';

type Props = {
  action: string,
  actioning: string,
  autofocus: boolean,
  instructions: string,
  onSignUp?: (DripPayload) => mixed,
  onSignUpError?: (DripPayload) => mixed,
  success: string,
  title: string
}

type State = {
  email: string,
  errors: { [string]: string },
  isSending: boolean,
  isValid: boolean,
  isSuccess: boolean
}

class SignUp extends Component<Props, State> {

  static defaultProps = {
    action: 'Subscribe',
    actioning: 'Subscribing...',
    autofocus: false,
    instructions: 'Enter your email below to get news updates and notifications when we add new tools.',
    success: 'Thanks for signing up!',
    title: 'Sign up to stay updated'
  }

  constructor(props: Props) {
    super(props);

    let email = '';

    if (window.Modernizr.localstorage) {
      const _email = localStorage.getItem('email');
      if (_email && validateEmail(_email)) {
        email = _email;
      }
    }

    const state = {
      email: email,
      errors: {},
      isSending: false,
      isSuccess: false,
      isValid: false
    };

    this.state = state;
  }

  handleChange = (key: string, value: string) => {
    this.setState({ [key]: value }, () => {
      const isValid = this.validate();
      let errors = { ...this.state.errors };
      if (isValid) {
        errors = {};
      }
      this.setState({ errors, isValid });
    });
  }

  handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!this.validate()) {
      this.setState({
        errors: {
          email: 'is not a valid email'
        }
      });
      return;
    }

    this.setState({ isSending: true });

    Drip.identify({
      email: this.state.email,
      tags: ['BaartTools', 'SignUp']
    }).then((visitor: DripPayload) => {
      // console.log('Drip success', visitor);
      if (visitor && visitor.hasOwnProperty('visitor_uuid')) {
        Drip.persistLocal(visitor);
        this.setState({ isSuccess: true });
        this.reset();
        if (this.props.onSignUp) {
          this.props.onSignUp(visitor);
        }
      }
    }, (error: DripPayload) => {
      // console.error('Drip error', error);
      if (this.props.onSignUpError) {
        this.props.onSignUpError(error);
      }
      this.setState({ isSending: false });
    });
  }

  reset() {
    this.setState({
      email: '',
      errors: {},
      isSending: false,
      isValid: false
    });
  }

  validate = () => {
    return validateEmail(this.state.email);
  }

  render() {
    const { action, actioning, autofocus, instructions, success, title } = this.props;
    const { isSending, isSuccess } = this.state;

    return (
      <div>
        <h3>{title}</h3>
        {
          isSuccess ? (
            <p className="instructions">{success}</p>
          ) : (
            <form className="sign-up limit-width" onSubmit={this.handleSubmit}>
              <p className="instructions">{instructions}</p>
              <LabeledInput
                autocomplete="email"
                autofocus={autofocus}
                error={this.state.errors.email}
                name="email"
                onChange={this.handleChange}
                placeholder="Email address"
                value={this.state.email}
              />
              <Button disabled={isSending} primary block>
                {isSending ? actioning : action }
              </Button>
            </form>
          )
        }
      </div>
    );
  }

}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.js